export var getLimitedData = function (arr, reqLength, fromLast) {
    if (arr === void 0) { arr = null; }
    if (fromLast === void 0) { fromLast = false; }
    if (arr == null)
        return void 0;
    if (!reqLength)
        return arr[arr.length - 1];
    if (fromLast) {
        return arr.slice(Math.max(arr.length - reqLength, 0));
    }
    else {
        return arr.slice(0, reqLength);
    }
};
